export class BankAccountModel {
  iban?: string;
  bic?: string;
  holder?: string;
  bankName?: string;

  //acceptedSepa?: string;
  //sepaAcceptedDate?: Date;
}
